<template>
  <div class="page-skeleton">
    <header id="page-skeleton-thee-header">
      <div id="page-skeleton-thee-left" class="left">
        <slot name="header-left" />
      </div>
      <div id="page-skeleton-thee-right" class="right">
        <slot name="header-right" />
      </div>
    </header>

    <section id="page-skeleton-thee-section">
      <slot name="container" />
    </section>

    <slot name="default" />
  </div>
</template>

<script>
export default {
  data() {
    return {}
  },
  mounted() {
    this.setElementMargin()
  },
  methods: {
    setElementMargin() {
      let left = document.getElementById('page-skeleton-thee-left')
      let right = document.getElementById('page-skeleton-thee-right')
      if (left && left.children && left.children.length) {
        left.children[left.children.length - 1].style.marginRight = 0
      }
      if (right && right.children && right.children.length) {
        right.children[0].style.marginLeft = 0
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.page-skeleton {
  display: flex;
  font-size: 14px;
  height: 100%;
  padding: 12px;
  min-width: 1680px;
  flex-direction: column;
  background-color: #fff;
  border-radius: 4px;

  header {
    display: flex;
    height: 40px;
    align-items: center;
    justify-content: space-between;
    .left {
      display: flex;
      align-items: center;
      justify-content: space-between;
      > * {
        margin-right: 15px;
      }
    }
    .right {
      display: flex;
      align-items: center;
      justify-content: space-between;
      > * {
        margin-left: 15px;
      }
    }
  }

  section {
    height: calc(100vh - 140px);
    margin-top: 12px;
    overflow: auto;
  }
}
</style>
